import {
  ActionFunctionArgs,
  Outlet,
  redirect,
  useLocation,
  useNavigate,
} from "react-router-dom";
import toast from "react-hot-toast";
import { Breadcrumb } from "../../components/Breadcrumb";
import { ImageLibraryEdit, ImageLibraryEditAction, ImageLibraryEditLoader } from "./ImageLibraryEdit";
import { ImageLibraryList, ImageLibraryListLoader } from "./ImageLibraryList";
import { Item } from "../../types/item";
import { ImageLibraryCreate, ImageLibraryCreateAction } from "./ImageLibraryCreate";
import { createApolloClient } from "../../providers/ApolloClientFactory";
import { ImageLibraryClone, ImageLibraryCloneAction, ImageLibraryCloneLoader } from "./ImageLibraryClone";
import {DELETE_IMAGE_LIBRARY} from "./mutations";

const client = createApolloClient();

const ImageLibraryIndex = () => {
  const location = useLocation();
  const navigate = useNavigate();

  if (location.pathname === "/image-library") {
    navigate(`/image-library/list`);
  }

  return (
    <>
      <Outlet />
    </>
  );
};

const imageLibraryDeleteAction = async ({ params }: ActionFunctionArgs) => {
  const { id } = params;
  try {
    await client.mutate({
      mutation: DELETE_IMAGE_LIBRARY,
      variables: { id },
    });
    toast.success("Image Library Item Deleted");
    return redirect(`/image-library/list`);
  } catch (error) {
    toast.error(
      `Failed to delete Image Library Item: ${error}`
    );
    return null;
  }
};

export const imageLibraryRouter = {
  path: "/image-library",
  id: "image-library",
  element: <ImageLibraryIndex />,
  handle: {
    crumb: () => (
      <Breadcrumb name="Image Library" href="/image-library/list" />
    ),
  },
  children: [
    {
      path: "list",
      id: "image-library-list",
      element: <ImageLibraryList />,
      loader: ImageLibraryListLoader,
    },
    {
      path: "create",
      id: "image-library-create",
      element: <ImageLibraryCreate />,
      action: ImageLibraryCreateAction,
      handle: {
        crumb: () => (
          <Breadcrumb
            name={`Create Image Library Item`}
            href={`/image-library/create`}
          />
        ),
      },
    },
    {
      path: ":id/clone",
      id: "image-library-clone",
      element: <ImageLibraryClone />,
      action: ImageLibraryCloneAction,
      loader: ImageLibraryCloneLoader,
      handle: {
        crumb: (data: Item) => (
          <Breadcrumb
            name={`Clone ${data.name}`}
            href={`/image-library/${data.id}`}
          />
        ),
      },
    },
    {
      path: ":id/edit",
      id: "image-library-edit",
      element: <ImageLibraryEdit />,
      loader: ImageLibraryEditLoader,
      action: ImageLibraryEditAction,
      handle: {
        crumb: (data: Item) => (
          <Breadcrumb
            name={`Edit ${data.name}`}
            href={`/image-library/${data.id}/edit`}
          />
        ),
      },
    },
    {
      path: ":id/delete",
      id: "image-library-delete",
      action: imageLibraryDeleteAction,
    },
  ],
};
